import { Link } from 'react-router-dom';
import { useScrapers, useSystemSummary } from '../api/queries';
import { STATE_META, deriveScraperState } from '../lib/scraperState';

/** Always-visible engine summary: one tick per scraper, coloured by state,
 *  so a failure is visible from any page. Links to Sources. */
export function StatusStrip() {
  const { data: scrapers, error } = useScrapers();
  const { data: summary } = useSystemSummary();
  const worker = summary?.worker;

  return (
    <footer className="strip" aria-label="Engine status">
      <Link to="/scrapers" className="strip-ticks" title="Open Sources">
        {error ? (
          <span className="strip-err">scrapers unavailable</span>
        ) : (
          scrapers?.map((s) => {
            const state = deriveScraperState(s);
            return (
              <span
                key={s.name}
                className={`strip-tick ${STATE_META[state].live ? 'live' : ''}`}
                style={{ background: STATE_META[state].dot }}
                title={`${s.name} · ${STATE_META[state].label}`}
              />
            );
          })
        )}
      </Link>
      <span className="strip-item">
        <span className={`strip-led ${worker?.alive ? 'ok' : 'bad'}`} />
        worker {worker ? (worker.alive ? `alive · ${worker.jobs ?? '?'} jobs` : 'down') : '—'}
      </span>
      <span className="strip-item num">{summary?.sent_today ?? '—'} sent / 24h</span>
      <span className="strip-item strip-mode">webhooks · {summary?.webhook.mode ?? '—'}</span>
      <span className="strip-spacer" />
      {summary?.commit && <span className="strip-item mono-sm">{summary.commit}</span>}
    </footer>
  );
}
